import { LicenseInfo } from '@mui/x-license-pro';
import { getConfig } from "../config/runtimeConfig";

LicenseInfo.setLicenseKey(getConfig("REACT_APP_DATA_GRID_PRO", ''))

export default function MuiXLicense() {
  return null;
}
